module.exports = __webpack_public_path__ + "static/img/software0.1643558.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software0.jpg
// module id = uv9E
// module chunks = 2